window.popper = {
    close: function () {
        event.stopPropagation();
        $('.popper').hide();
    }
}